// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fee31ead","667":"86d34a55","977":"251f8ed0"}[chunkId] + ".chunk.js";
};